import styled from "styled-components";
import Image from "../../../../../base/multimedia/image/index.js";
import { FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const ComarketingWrapper = styled.div.withConfig({
    displayName: "styled__ComarketingWrapper",
    componentId: "sc-c8c0aaaf-0"
})`
	${FlexMixin({
    direction: 'row'
})}
	width: 100%;
	min-height: 204px;
	overflow-x: scroll;
`;
export const ComarketingImage = styled(Image).withConfig({
    displayName: "styled__ComarketingImage",
    componentId: "sc-c8c0aaaf-1"
})`
	min-width: calc(95% - 8px);

	&:not(:last-of-type) {
		margin-right: 8px;
	}

	& figure {
		height: 100%;
	}

	& img {
		height: 100%;
		width: auto;
		object-fit: contain;
	}
`;

//# sourceMappingURL=styled.js.map